<template>
    <div class="modal fade" id="filterModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content shadow-sm">
                <div class="modal-header">
                    <h5 class="modal-title color-scope bolder" id="exampleModalLabel">Filter</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <!-- <p class="bolder mb-3">Status</p>

                    <div class="row">
                        <div class="col-6">                                        
                            <button class="btn bg-scope rounded-pill p-2 font-12 text-white bolder form-control">Shipped</button>
                        </div>
                        <div class="col-6">                                    
                            <button class="btn bg-border rounded-pill font-12 bolder p-2 form-control shadow-sm">Processing</button>
                        </div>
                    </div>

                    <p class="bolder mb-3 mt-5">Method</p>

                    <div class="row">
                        <div class="col-6">                                    
                            <button class="btn bg-border rounded-pill font-12 bolder p-2 form-control shadow-sm">Self-Collection</button>
                        </div>
                        <div class="col-6">                                        
                            <button class="btn bg-scope rounded-pill p-2 font-12 text-white bolder form-control">Frieighted</button>
                        </div>
                    </div> -->

                    <p class="bolder mb-3 mt-5">Select date range</p>

                    <div class="row">
                        <div class="col-12">                                    
                            <input type="date" v-model="obj_order.startdate" class="form-control border-b" style="height: 55px;">
                        </div>
                        <div class="col-12 mt-3">                                               
                            <input type="date" v-model="obj_order.startdate" class="form-control border-b" style="height:55px">
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FilterModal",
};
</script>
<style scoped>
.modal-dialog { max-width: 20%; margin: 0 0 0 80%;}
.modal {z-index: 9999;width: 100%;height: 100%;}
.modal-content {height: 100vh;border-radius: 0;border: none;border-left:1px solid #dee2e6 !important;}
.modal-title {font-size: 19px;}
.modal-header { border-bottom: 1px solid #dee2e638;}
.border-b{border:2px solid #c1c1c1}
</style>